module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editWaveDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.WV0000))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.WV0024) + ":")]), _vm._v("\n            " + _vm._s(_vm.selectedProjectData.ProjectId) + " -\n            " + _vm._s(_vm.selectedProjectData.ProjectName) + ",\n            "), _c('b', [_vm._v(_vm._s(_vm.lang.WV0025) + ":")]), _vm._v("\n            " + _vm._s(_vm.selectedProjectData.ClientId) + " -\n            " + _vm._s(_vm.selectedProjectData.ClientName) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group searchbar col-md-6",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterWaveString),
      expression: "filterWaveString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "id": "inputSearchFilter",
      "placeholder": _vm.lang.WV0001
    },
    domProps: {
      "value": (_vm.filterWaveString)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filterWaveString = $event.target.value
      }, function($event) {
        return _vm.doFilteringWaves()
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group searchbar col-md-6",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'btn-warning': _vm.wavePositionsDirty
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveWavePositions()
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.WV0026) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "table-container table-waves",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover",
    attrs: {
      "id": "wavesTable"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.WV0002) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.WV0003) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.WV0004) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.WV0005) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.WV0027) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.WV0039) + "\n                        ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredWaves), function(wave) {
    return _c('tr', {
      key: wave.WaveGuid,
      class: {
        info: _vm.isWaveSelected(wave.WaveGuid)
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectWave(wave.WaveGuid)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(wave.WaveId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(wave.WaveName))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.globals.getLocalizedDateFromIsoTimestamp(
      wave.WaveSince
    )) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.globals.getLocalizedDateFromIsoTimestamp(
      wave.WaveUntil
    )) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (wave.WavePosition),
        expression: "wave.WavePosition"
      }],
      staticClass: "form-control text-center nopadding",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(wave, "WavePosition", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.reorderWaves(), (_vm.wavePositionsDirty = true)
        }],
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, _vm._l((_vm.waves), function(w) {
      return _c('option', {
        key: w.WavePosition,
        domProps: {
          "value": w.WavePosition
        }
      }, [_vm._v("\n                                " + _vm._s(w.WavePosition) + "\n                              ")])
    }), 0)])]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding",
      staticStyle: {
        "width": "90%",
        "margin-left": "5px"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (wave.LeadAgencyId),
        expression: "wave.LeadAgencyId"
      }],
      staticClass: "form-control",
      attrs: {
        "id": 'inputWaveEditLeadAgency_' + wave.WaveId,
        "allowClear": true
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(wave, "LeadAgencyId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option'), _vm._v(" "), _vm._l((_vm.leadAgencies), function(agency) {
      return _c('option', {
        key: agency.AgencyId,
        domProps: {
          "value": agency.AgencyId
        }
      }, [_vm._v("\n                                " + _vm._s(agency.AgencyName) + "\n                              ")])
    })], 2)])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-right": "0"
    }
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-wave-edit",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#editWaveTab",
      "id": "project-management-wave-edit-add-wave-tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'editWaveTab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0006))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#assignScenariosTab",
      "id": "project-management-wave-edit-assign-scenarios-tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'assignScenariosTab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0007) + "\n                    ")])]), _vm._v(" "), _c('li', [(_vm.carModelList.length > 0) ? _c('a', {
    attrs: {
      "href": "#carModelDistributionTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'carModelDistributionTab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0029) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('li', [(_vm.feature.isAudiTarget && _vm.feature.isEnabled('shopperApproval')) ? _c('a', {
    attrs: {
      "href": "#competitorCarModelDistributionTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'competitorCarModelDistributionTab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0035) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('li', [(_vm.feature.isAudiTarget) ? _c('a', {
    attrs: {
      "href": "#brandVisitsTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'brandVisitsTab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0045) + "\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "editWaveTab"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputWaveName"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0003))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.WaveName),
      expression: "selectedWave.WaveName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputWaveName"
    },
    domProps: {
      "value": (_vm.selectedWave.WaveName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedWave, "WaveName", $event.target.value)
      }, function($event) {
        _vm.selectedWaveDirty = true
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputWaveStartDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputWaveStartDate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.WaveSince),
      expression: "selectedWave.WaveSince"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputWaveStartDate"
    },
    domProps: {
      "value": (_vm.selectedWave.WaveSince)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedWave, "WaveSince", $event.target.value)
      }, function($event) {
        _vm.selectedWaveDirty = true
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputWaveEndDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputWaveEndDate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.WaveUntil),
      expression: "selectedWave.WaveUntil"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputWaveEndDate"
    },
    domProps: {
      "value": (_vm.selectedWave.WaveUntil)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedWave, "WaveUntil", $event.target.value)
      }, function($event) {
        _vm.selectedWaveDirty = true
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputWavePlannedStartDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0042))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputWavePlannedStartDate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.WavePlannedSince),
      expression: "selectedWave.WavePlannedSince"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputWavePlannedStartDate"
    },
    domProps: {
      "value": (_vm.selectedWave.WavePlannedSince)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedWave, "WavePlannedSince", $event.target.value)
      }, function($event) {
        _vm.selectedWaveDirty = true
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputWavePlannedEndDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0043))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputWavePlannedEndDate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.WavePlannedUntil),
      expression: "selectedWave.WavePlannedUntil"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputWavePlannedEndDate"
    },
    domProps: {
      "value": (_vm.selectedWave.WavePlannedUntil)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedWave, "WavePlannedUntil", $event.target.value)
      }, function($event) {
        _vm.selectedWaveDirty = true
      }]
    }
  })])]), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputWaveEditCostCenter"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0028))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.CostCenter),
      expression: "selectedWave.CostCenter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputWaveEditCostCenter"
    },
    domProps: {
      "value": (_vm.selectedWave.CostCenter)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedWave, "CostCenter", $event.target.value)
      }, function($event) {
        _vm.selectedWaveDirty = true
      }]
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputWaveEditWaveInfo"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0033))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.WaveInfo),
      expression: "selectedWave.WaveInfo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputWaveEditWaveInfo",
      "maxlength": "500",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.selectedWave.WaveInfo)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedWave, "WaveInfo", $event.target.value)
      }, function($event) {
        _vm.selectedWaveDirty = true
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputWaveReportingVisibility"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0008))]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left",
      "margin-left": "15px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.ReportingVisibility),
      expression: "selectedWave.ReportingVisibility"
    }],
    attrs: {
      "type": "checkbox",
      "id": "inputWaveReportingVisibility"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectedWave.ReportingVisibility) ? _vm._i(_vm.selectedWave.ReportingVisibility, null) > -1 : (_vm.selectedWave.ReportingVisibility)
    },
    on: {
      "input": function($event) {
        _vm.selectedWaveDirty = true
      },
      "change": [function($event) {
        var $$a = _vm.selectedWave.ReportingVisibility,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.selectedWave, "ReportingVisibility", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.selectedWave, "ReportingVisibility", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.selectedWave, "ReportingVisibility", $$c)
        }
      }, function($event) {
        return _vm.waveReportingVisibilityChanged(_vm.selectedWave)
      }]
    }
  }), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputWaveWithoutApprovel"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0040))]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left",
      "margin-left": "15px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.WaveWithoutApprovel),
      expression: "selectedWave.WaveWithoutApprovel"
    }],
    attrs: {
      "type": "checkbox",
      "id": "inputWaveWithoutApprovel"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectedWave.WaveWithoutApprovel) ? _vm._i(_vm.selectedWave.WaveWithoutApprovel, null) > -1 : (_vm.selectedWave.WaveWithoutApprovel)
    },
    on: {
      "input": function($event) {
        _vm.selectedWaveDirty = true
      },
      "change": function($event) {
        var $$a = _vm.selectedWave.WaveWithoutApprovel,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.selectedWave, "WaveWithoutApprovel", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.selectedWave, "WaveWithoutApprovel", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.selectedWave, "WaveWithoutApprovel", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputLocalWave"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0041))]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left",
      "margin-left": "15px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.IsLocalWave),
      expression: "selectedWave.IsLocalWave"
    }],
    attrs: {
      "type": "checkbox",
      "id": "inputLocalWave"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectedWave.IsLocalWave) ? _vm._i(_vm.selectedWave.IsLocalWave, null) > -1 : (_vm.selectedWave.IsLocalWave)
    },
    on: {
      "input": function($event) {
        _vm.selectedWaveDirty = true
      },
      "change": function($event) {
        var $$a = _vm.selectedWave.IsLocalWave,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.selectedWave, "IsLocalWave", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.selectedWave, "IsLocalWave", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.selectedWave, "IsLocalWave", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedWave.WaveName
    },
    on: {
      "click": function($event) {
        return _vm.createNewWave()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.WV0009) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-success btn-top-bar",
    class: {
      'btn-warning': _vm.selectedWaveDirty
    },
    attrs: {
      "id": "project-management-wave-save",
      "type": "button",
      "disabled": !_vm.canSaveWave()
    },
    on: {
      "click": function($event) {
        return _vm.saveSelectedWave()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("save")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.WV0010) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedWave.WaveId || !_vm.globals.isAccessAllowed('LoopOp_ProjectWaves_Delete')
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteWaveConfirmationDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("delete")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.WV0011) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedWave.WaveId
    },
    on: {
      "click": function($event) {
        return _vm.showWaveStatus()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("insert_chart")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.WV0034) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "assignScenariosTab"
    }
  }, [_c('div', {
    staticClass: "form-group searchbar",
    staticStyle: {
      "margin-right": "15px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterScenarioString),
      expression: "filterScenarioString"
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-width": "40%",
      "display": "inline",
      "float": "left"
    },
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.WV0001
    },
    domProps: {
      "value": (_vm.filterScenarioString)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filterScenarioString = $event.target.value
      }, function($event) {
        return _vm.doFilteringScenarios()
      }]
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-success",
    class: {
      'btn-warning': _vm.selectedWaveDirty
    },
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "id": "saveAssignment",
      "type": "button",
      "disabled": !_vm.canSaveWave()
    },
    on: {
      "click": function($event) {
        return _vm.saveSelectedWave()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.WV0010) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table table-striped table-hover",
    attrs: {
      "id": "scenarioTable"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0012) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0013) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0014) + "\n                            ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredScenarios), function(scenario) {
    return _c('tr', {
      key: scenario.ScenarioGuid,
      class: {
        info: _vm.isScenarioSelected(scenario.ScenarioGuid),
        'cursor-not-allowed': !_vm.selectedWave.WaveId,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectScenario(scenario.ScenarioGuid)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v("\n                              " + _vm._s(scenario.ScenarioId) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("\n                              " + _vm._s(scenario.ScenarioName) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "60%"
      }
    }, [_vm._v("\n                              " + _vm._s(scenario.ScenarioDescription) + "\n                            ")])])
  }), 0)])])]), _vm._v(" "), (_vm.carModelList.length > 0) ? _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "carModelDistributionTab"
    }
  }, [_c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0030) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SA0012))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.lang.CMM002))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0031) + " (%)\n                            ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.carModelList), function(model) {
    return _c('tr', {
      key: model.CarModelGuid
    }, [_c('td', [_vm._v(_vm._s(model.CarModelName))]), _vm._v(" "), _c('td', [(model.ImporterGuid) ? _c('div', [_vm._l((_vm.importerList), function(importer) {
      return [(importer.ImporterGuid === model.ImporterGuid) ? _c('div', {
        key: importer.ImporterGuid
      }, [_vm._v("\n                                    " + _vm._s(importer.ImporterName) + "\n                                  ")]) : _vm._e()]
    })], 2) : _vm._e()]), _vm._v(" "), _c('td', _vm._l((model.CarSegments), function(modelCarSegment, index) {
      return _c('span', {
        key: modelCarSegment.CarSegmentGuid
      }, [_vm._l((_vm.segmentList), function(segment) {
        return [(segment.CarSegmentGuid === modelCarSegment.CarSegmentGuid) ? _c('span', {
          key: segment.CarSegmentGuid
        }, [(index != 0) ? _c('span', [_vm._v(" ,")]) : _vm._e(), _vm._v("\n                                    " + _vm._s(segment.CarSegmentName) + "\n                                  ")]) : _vm._e()]
      })], 2)
    }), 0), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (model.Distribution),
        expression: "model.Distribution",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control text-center nopadding",
      attrs: {
        "type": "number",
        "min": "0",
        "max": "100"
      },
      domProps: {
        "value": (model.Distribution)
      },
      on: {
        "change": function($event) {
          (_vm.selectedWaveDirty = true), _vm.validateDistributionValue(model, 'audi')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(model, "Distribution", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])])])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-success",
    class: {
      'btn-warning': _vm.selectedWaveDirty
    },
    staticStyle: {
      "float": "right",
      "margin-right": "20px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.canSaveWave()
    },
    on: {
      "click": function($event) {
        return _vm.saveSelectedWave()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.WV0010) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.feature.isAudiTarget && _vm.feature.isEnabled('shopperApproval')) ? _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "competitorCarModelDistributionTab"
    }
  }, [_c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0044) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0030) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0031) + " (%)\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0036) + "\n                            ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.selectedWave.CompetitorCarModelDistribution), function(model, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (model.CompetitorCarBrand),
        expression: "model.CompetitorCarBrand"
      }],
      key: model.CompetitorCarBrand,
      staticClass: "form-control",
      attrs: {
        "allowClear": true
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(model, "CompetitorCarBrand", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.selectedWaveDirty = true
        }]
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "value": ""
      }
    }, [_vm._v(_vm._s(_vm.lang.WV0048))]), _vm._v(" "), _vm._l((_vm.brands), function(brand) {
      return _c('option', {
        key: brand,
        domProps: {
          "value": brand
        }
      }, [_vm._v("\n                                    " + _vm._s(brand) + "\n                                  ")])
    })], 2)])]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (model.CompetitorCarModel),
        expression: "model.CompetitorCarModel"
      }],
      staticClass: "form-control text-center nopadding",
      attrs: {
        "type": "text",
        "maxlength": "200"
      },
      domProps: {
        "value": (model.CompetitorCarModel)
      },
      on: {
        "change": function($event) {
          _vm.selectedWaveDirty = true
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(model, "CompetitorCarModel", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('input', {
      staticClass: "form-control text-center nopadding",
      attrs: {
        "type": "number",
        "min": "0",
        "max": "100"
      },
      domProps: {
        "value": parseFloat(((model.Distribution || 0) * 100).toFixed(4))
      },
      on: {
        "change": function($event) {
          (
            model.Distribution = ($event.target.value || 0) / 100),
          (_vm.selectedWaveDirty = true),
          _vm.validateDistributionValue(model, 'competitor')
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn nopadding",
      on: {
        "click": function($event) {
          return _vm.deleteCompetitorCarModel(index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-red"
    }, [_vm._v("clear")])])])])
  }), 0)]), _vm._v(" "), (_vm.getCompetitorDistributionsInfoToolTip().length > 0) ? _c('span', {
    staticStyle: {
      "float": "right",
      "margin-right": "25px"
    },
    attrs: {
      "id": "competitorDistributionsInfo"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24 text-info",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v("info")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "competitorDistributionsInfo",
      "delay": _vm.globals.tooltipDelay,
      "triggers": "hover"
    }
  }, [_vm._l((_vm.getCompetitorDistributionsInfoToolTip()), function(line) {
    return [_vm._v("\n                              " + _vm._s(line) + " "), _c('br')]
  })], 2)], 1) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    staticStyle: {
      "float": "left",
      "margin-left": "20px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedWave.WaveName
    },
    on: {
      "click": function($event) {
        return _vm.addCompetitorCarModel()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.WV0037) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-success",
    class: {
      'btn-warning': _vm.selectedWaveDirty
    },
    staticStyle: {
      "float": "right",
      "margin-right": "20px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.canSaveWave()
    },
    on: {
      "click": function($event) {
        return _vm.saveSelectedWave()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.WV0010) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "brandVisitsTab"
    }
  }, [_c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n                               \n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0046) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0051) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0036) + "\n                            ")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.selectedWave.BrandVisits), function(model, index) {
    return [_c('tr', [_c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (model.BrandName),
        expression: "model.BrandName"
      }],
      key: model.BrandName,
      staticClass: "form-control",
      attrs: {
        "allowClear": true
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(model, "BrandName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.selectedWaveDirty = true
        }]
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "value": ""
      }
    }, [_vm._v(_vm._s(_vm.lang.WV0048))]), _vm._v(" "), _c('option', {
      attrs: {
        "disabled": _vm.canSelectBrand(_vm.selectedWave, 'Audi')
      }
    }, [_vm._v("\n                                      Audi\n                                    ")]), _vm._v(" "), _vm._l((_vm.brands), function(brand) {
      return _c('option', {
        key: brand,
        attrs: {
          "disabled": _vm.canSelectBrand(_vm.selectedWave, brand)
        },
        domProps: {
          "value": brand
        }
      }, [_vm._v("\n                                      " + _vm._s(brand) + "\n                                    ")])
    })], 2)])]), _vm._v(" "), _c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn nopadding",
      on: {
        "click": function($event) {
          return _vm.addVisitToBrandVisit(model)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-green"
    }, [_vm._v("add")])]), _vm._v(" "), _c('button', {
      staticClass: "btn nopadding",
      on: {
        "click": function($event) {
          return _vm.removeBrandVisit(_vm.selectedWave, index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-red"
    }, [_vm._v("remove")])])])]), _vm._v(" "), _vm._l((model.Visits), function(visit, idx) {
      return _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
        staticClass: "nopadding"
      }, [_c('div', {
        staticClass: "form-group nopadding"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (visit.Frequency),
          expression: "visit.Frequency"
        }],
        staticClass: "form-control text-right nopadding",
        attrs: {
          "type": "number",
          "min": "0",
          "max": "100"
        },
        domProps: {
          "value": (visit.Frequency)
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(visit, "Frequency", $event.target.value)
          }, function($event) {
            (_vm.selectedWaveDirty = true, visit.Frequency = _vm.validateVisitValue(visit.Frequency))
          }]
        }
      })])]), _vm._v(" "), _c('td', {
        staticClass: "nopadding"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (visit.NoOfVisits),
          expression: "visit.NoOfVisits"
        }],
        staticClass: "form-control text-right nopadding",
        attrs: {
          "type": "number",
          "min": "0",
          "max": "100"
        },
        domProps: {
          "value": (visit.NoOfVisits)
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(visit, "NoOfVisits", $event.target.value)
          }, function($event) {
            (_vm.selectedWaveDirty = true, visit.NoOfVisits = _vm.validateVisitValue(visit.NoOfVisits))
          }]
        }
      })]), _vm._v(" "), _c('td', [_c('button', {
        staticClass: "btn nopadding",
        attrs: {
          "disabled": !_vm.canRemoveVisit(_vm.selectedWave, index)
        },
        on: {
          "click": function($event) {
            return _vm.removeVisit(_vm.selectedWave, index, idx)
          }
        }
      }, [_c('i', {
        staticClass: "material-icons md-24 text-red"
      }, [_vm._v("remove")])])])])
    })]
  })], 2)]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "margin-right": "50px"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.lang.WV0050) + ":")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getTotalNumberOfVisits(_vm.selectedWave)))])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    staticStyle: {
      "float": "left",
      "margin-left": "20px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedWave.WaveName
    },
    on: {
      "click": function($event) {
        return _vm.addNewBrandVisit(_vm.selectedWave)
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.WV0047) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-success",
    class: {
      'btn-warning': _vm.selectedWaveDirty
    },
    staticStyle: {
      "float": "right",
      "margin-right": "20px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.canSaveWave()
    },
    on: {
      "click": function($event) {
        return _vm.saveSelectedWave()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.WV0010) + "\n                    ")])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.WV0015) + "\n          ")])])])])]), _vm._v(" "), _c('WaveStatusModal')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e5ea545","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectManagement/WaveEditModal.vue
// module id = 1661
// module chunks = 1